import { useEffect, useState } from 'react'
import axios from 'axios'
import { Link, useParams } from 'react-router-dom'
import { KeyRound, PackageCheck } from 'lucide-react'
import PageHeader from '../components/PageHeader'
import OrderList from '../components/OrderList'
import type { ShopOrder } from '../types/Shop'

const GuestOrders = () => {
  const { token } = useParams()
  const [orders, setOrders] = useState<ShopOrder[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    if (!token) {
      setError('Lien de commandes invalide.')
      setLoading(false)
      return
    }
    axios.get<ShopOrder[]>(`/api/shop/guest-orders/${encodeURIComponent(token)}`)
      .then(({ data }) => { setOrders(data); setError('') })
      .catch((requestError) => setError(axios.isAxiosError(requestError) ? requestError.response?.data?.message || 'Ce lien n’est plus valide.' : 'Ce lien n’est plus valide.'))
      .finally(() => setLoading(false))
  }, [token])

  return (
    <div className="space-y-8">
      <PageHeader eyebrow="Lien personnel" title="Mes commandes" description="Cet espace en lecture seule regroupe les commandes passées avec votre adresse e-mail." icon={<PackageCheck />} />
      {loading && <div className="shop-orders-loading">Vérification de votre lien…</div>}
      {!loading && error && (
        <div className="empty-state">
          <KeyRound className="mx-auto mb-4 h-10 w-10 text-red-600" />
          <h2>Lien indisponible</h2>
          <p className="mt-2 text-gray-600">{error}</p>
          <Link to="/boutique" className="btn-secondary mt-6">Retour à la boutique</Link>
        </div>
      )}
      {!loading && !error && <OrderList orders={orders} />}
    </div>
  )
}

export default GuestOrders
